import { Link, useParams } from "react-router-dom";
import ShelfArticlePage from "../components/ShelfArticlePage";
import { SHELF_ARTICLES } from "../data/shelfArticles";

const ShelfArticle = () => {
  const { slug } = useParams();
  const config = SHELF_ARTICLES[slug];

  if (!config) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
        style={{ background: "var(--bg)", color: "var(--text)" }}
      >
        <h1 className="font-serif text-3xl mb-4">Shelf not found</h1>
        <Link
          to="/shelves"
          className="text-sm px-5 py-2.5 rounded-full border"
          style={{ borderColor: "var(--border)", color: "var(--brand)" }}
        >
          Back to shelves
        </Link>
      </div>
    );
  }

  return <ShelfArticlePage config={config} slug={slug} />;
};

export default ShelfArticle;
